import TaskService from "./TaskService"
import UserService from "./UserService"

const taskService = new TaskService()
const userService = new UserService()

export {taskService, userService}
